import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import FaqService from "../../services/FaqService";
import IFaq from "../../types/FaqType";

const Faq = () => {
  const [data, setData] = useState<Array<IFaq>>([]);
  const [currentData, setCurrentData] = useState<IFaq | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [loading, setLoading] = useState<boolean>(false);

  const getData = () => {
    setLoading(true);
    FaqService.getAll()
      .then((response: any) => {
        setData(response.data.data.faqs);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const setActiveData = (card: IFaq, index: number) => {
    setCurrentData(card);
    setCurrentIndex(index);
  };

  const deleteCard = (id: any) => {
    setLoading(true);
    FaqService.remove(id)
      .then((response: any) => {
        let newData = data.filter((d) => d._id !== id);
        setData(newData);
        if (response.data.status === "success") {
          setLoading(false);
          toast("Deleted successfully");
        }
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <div className="list row">
      <div className="col-md-8">
        <div className="d-flex justify-content-between mt-5">
          <h3>Faq List</h3>
          <Link to="/create/faq" className="btn btn-sm btn-primary">
            Create
          </Link>
        </div>
        {!loading ? (
          <ul className="card-body list-group">
            {data &&
              data?.map((res, index) => (
                <li
                  className={
                    "d-flex align-items-center justify-content-between list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }
                  onClick={() => setActiveData(res, index)}
                  key={index}
                >
                  {res.questionRu}
                  <div>
                    <div className="btn btn-light-secondary btn-sm ml-5">
                      {res?.for.toUpperCase()}
                    </div>
                    <Link
                      to={`/update/faq/${res._id}`}
                      className="btn btn-light-primary btn-sm ml-5"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => deleteCard(res._id)}
                      className="btn btn-light-danger btn-sm ml-5"
                    >
                      delete
                    </button>
                  </div>
                </li>
              ))}
          </ul>
        ) : (
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        )}
      </div>
      <div className="col-md-4">
        {currentData ? (
          <div>
            <h4>Card</h4>
            <div>
              <label>
                <strong>Question Ru:</strong>
              </label>{" "}
              {currentData.questionRu}
            </div>
            <div>
              <label>
                <strong>Question Uzk:</strong>
              </label>{" "}
              {currentData.questionUzk}
            </div>
            <div>
              <label>
                <strong>Question Uz:</strong>
              </label>{" "}
              {currentData.questionUzk}
            </div>
            <div>
              <label>
                <strong>Answer Ru:</strong>
              </label>{" "}
              {currentData.answerRu}
            </div>
            <div>
              <label>
                <strong>Answer Uzk:</strong>
              </label>{" "}
              {currentData.answerUzk}
            </div>
            <div>
              <label>
                <strong>Answer Uz:</strong>
              </label>{" "}
              {currentData.answerUz}
            </div>
          </div>
        ) : data ? (
          <div>
            <br />
            <p>Please click on a Card...</p>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Faq;
